import * as React from 'react';
import { useCallback, useState } from 'react';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Iframe } from 'modules/common';
import { CollectorInstallError } from 'graphql/types';
import { CollectorErrorListUnified } from './Setting/CollectorErrorListUnified';

const useStyles = makeStyles((theme) => ({
  iFrame: {
    border: theme.spacing(0),
    height: '100%',
    width: '100%',
    marginBottom: theme.spacing(6)
  },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  div: {
    height: '100%',
    width: '100%'
  },
  errorDiv: {
    marginLeft: theme.spacing(2)
  }
}));

type CollectorOverviewPageProps = {
  descriptionSrc: string;
  retryUrl: string;
  installId: string;
  error: CollectorInstallError[];
};

const CollectorOverviewPage: React.FC<CollectorOverviewPageProps> = ({
  descriptionSrc,
  retryUrl,
  installId,
  error
}: CollectorOverviewPageProps) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const onFrameLoaded = useCallback(() => {
    setIsLoading(false);
  }, [setIsLoading]);
  return (
    <div data-testid="collector-overview-page" className={classes.div}>
      {installId && (
        <div className={classes.errorDiv}>
          <CollectorErrorListUnified
            data-testid="collectorDataList-testid"
            errors={error}
            retryURL={retryUrl || ''}
            installId={installId}
          />
        </div>
      )}
      {isLoading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress data-testid="overview-progress" />
        </div>
      ) : null}
      <Iframe
        onFrameLoad={onFrameLoaded}
        src={descriptionSrc}
        className={classes.iFrame}
        title={'Collector Overview'}
        frameId={'embedded-overview'}
      />
    </div>
  );
};
export default CollectorOverviewPage;
